import React from 'react';
import { LeftMenuItem } from '../shared/LeftMenuItem';
import { NotificationFlagsCategories } from '../../../../models/NotificationFlags/NotificationFlagsCategories';

export interface PracticeMenuItemProps {
    practice: any;
}

export const PracticeMenuItem = (props: PracticeMenuItemProps) => {
    const { practice } = props;

    return (
        <div className="flex-container">
            <LeftMenuItem
                icon="pe-7s-share"
                label={practice.name}
                to={`/practice/${practice.id}`}
                flagCode={`${NotificationFlagsCategories.PracticesCode}.${practice.id}`}
                className={
                    practice.id
                        ? 'vertical-nav-menu'
                        : 'vertical-nav-menu custom'
                }
                marginLeft={-15}
                trackingAction={practice.name}
                forceReload
            />
        </div>
    );
};
